export const config = {
    API_URL: 'https://api.omniflix.studio',
    RPC_URL: 'https://rpc.omniflix.network',
    REST_URL: 'https://rest.omniflix.network',
    DATA_LAYER: 'https://data-api.omniflix.studio',
    CHAIN_ID: 'omniflixhub-1',
    CHAIN_NAME: 'OmniFlix Hub',
    COIN_DENOM: 'FLIX',
    COIN_MINIMAL_DENOM: 'uflix',
    COIN_DECIMALS: 6,
    PREFIX: 'omniflix',
    LIVE_STREAM_WEB_SOCKET_URL: 'wss://staging-api.omniflix.studio/ws/',
};

export const contractAddresses = {
    MULTI_MINT_VIDEO_DROP: 'omniflix1s7knqqgyw20jm8yvqz0j66yd9r3hkv97adjslzgl676zkr8d700scjreqt',
    OPEN_EDITION_MINTER: 'omniflix1s7knqqgyw20jm8yvqz0j66yd9r3hkv97adjslzgl676zkr8d700scjreqt',
    WHITELIST: 'omniflix1wl97hxla3e8uv856gqn6dtq32504ctnfxpn39xme8dm0hf9cxw8qx500cy',
    MULTI_MINT_OPEN_EDITION_MINT: 'omniflix1wqw0smcqjvkxfnvnegny0dle2ng6t65uxvldhrth6qtcc0gj58hs69rxjd',
};

export const ACTIVITY_URL = 'https://activity-api.omniflix.studio';
export const EXPLORER_URL = 'https://www.mintscan.io/omniflix';

export const DEFAULT_TOTAL = 20;
export const DEFAULT_SORT_BY = 'created_at';
export const DEFAULT_ORDER = 'desc';
export const DEFAULT_SKIP = 0;
export const DEFAULT_LIMIT = 20;
export const DEFAULT_TABLE_LIMIT = 10;
export const DEFAULT_SEARCH = null;
export const DEFAULT_LAZY_FETCH_HEIGHT = 256;
export const TRANSACTION_SET_TIME_OUT = 3000;
export const COLLECTION_PREFIX = 'onftdenom';
export const DEFAULT_GAS_FEE = '500000';

export const chainId = config.CHAIN_ID;
export const chainName = config.CHAIN_NAME;
export const coinDenom = config.COIN_DENOM;
export const coinMinimalDenom = config.COIN_MINIMAL_DENOM;
export const coinDecimals = config.COIN_DECIMALS;
export const prefix = config.PREFIX;

export const OMNIFLIX_NUCLEUS_URL = 'https://omniflix.market';
export const RUNNER_URL = 'https://runner.omniflix.studio';
export const IPFS_URL = 'https://ipfs.omniflix.studio/ipfs';
export const IPFS_REFERENCE_PATH = 'ipfs://';
export const INSYNC_URL = 'https://omniflix.co';
export const STREAM_PAY_URL = 'https://sp.omniflix.network';
export const MINT_ACCESS = 'https://forms.gle/Aj3oc2fbcoCTX9KF7';
export const GAS_PRICE_STEP_LOW = 0.001;
export const GAS_PRICE_STEP_AVERAGE = 0.0025;
export const GAS_PRICE_STEP_HIGH = 0.025;

export const DEFAULT_UPLOAD_LIMIT = 2 * 1024 * 1024 * 1024;
export const DEFAULT_UPLOAD_LIMIT_RUNNER = 4 * 1024 * 1024 * 1024;

export const IPFS_GATEWAYS = [
    'https://ipfs-gateway-2.omniflix.studio/ipfs',
    'https://ipfs.omniflix.studio/ipfs',
    'https://ipfs-gateway.omniflix.studio/ipfs',
    'https://ipfs.io/ipfs',
];

export const gas = {
    LIST_NFT: 200000,
    MINT_NFT: 300000,
    ITC_CLAIM: 200000,
};

export const socialLinks = {
    TWITTER: 'https://twitter.com/OmniFlixNetwork',
    TELEGRAM: 'https://t.me/OmniFlixChat',
    DISCORD: 'https://discord.com/invite/6gdQ4yZSTC',
    GITHUB: 'https://github.com/OmniFlix',
    WEBSITE: 'https://omniflix.network/',
    YOUTUBE: 'https://www.youtube.com/OmniFlixNetwork',
};

export const defaultThumbnail = {
    CHANNEL: 'https://ipfs.omniflix.studio/ipfs/QmYktVJPCNS7JVXyWDJcWAztRgHvkoxnEPhpYGg7fwdNVS',
    IV: 'https://ipfs.omniflix.studio/ipfs/QmcuS8nG3rvGCRknYvhqEMGSgu6i55UhspXGgc5KaQaVuJ',
    IMAGE_OPTION: 'https://ipfs.omniflix.studio/ipfs/QmfPBWpa6Qrt9J5Lw2HueEXC1PmwwVEZj5DgMRvhrdutsQ',
    DEFAULT_BANNER: 'https://ipfs.omniflix.studio/ipfs/QmWV5iCqmZNbPoKvXaxykTz4vSRqY5vqKjGngzrps22Tnk',
};

export const appsLinks = {
    NUCLEUS: OMNIFLIX_NUCLEUS_URL,
    IN_SYNC: INSYNC_URL,
    TV: 'https://omniflix.tv',
};

export const walletExtensions = {
    LEAP: 'https://chrome.google.com/webstore/detail/leap-cosmos-wallet/fcfcfllfndlomdhbehjjcoimbgofdncg',
    COSMO_STATION: 'https://chrome.google.com/webstore/detail/cosmostation-wallet/fpkhgmpbidmiogeglndfbkegfdlnajnf',
    KEPLR: 'https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap',
};

export const chainConfig = {
    chainId: chainId,
    chainName,
    rpc: config.RPC_URL,
    rest: config.REST_URL,
    stakeCurrency: {
        coinDenom,
        coinMinimalDenom,
        coinDecimals,
    },
    bip44: {
        coinType: 118,
    },
    bech32Config: {
        bech32PrefixAccAddr: `${prefix}`,
        bech32PrefixAccPub: `${prefix}pub`,
        bech32PrefixValAddr: `${prefix}valoper`,
        bech32PrefixValPub: `${prefix}valoperpub`,
        bech32PrefixConsAddr: `${prefix}valcons`,
        bech32PrefixConsPub: `${prefix}valconspub`,
    },
    currencies: [
        {
            coinDenom,
            coinMinimalDenom,
            coinDecimals,
        },
    ],
    feeCurrencies: [
        {
            coinDenom,
            coinMinimalDenom,
            coinDecimals,
            gasPriceStep: {
                low: GAS_PRICE_STEP_LOW,
                average: GAS_PRICE_STEP_AVERAGE,
                high: GAS_PRICE_STEP_HIGH,
            },
        },
    ],
    coinType: 118,
    features: ['ibc-transfer'],
};

export const cosmoStationChainConfig = {
    chainId: chainId,
    chainName: chainName,
    addressPrefix: prefix,
    baseDenom: coinMinimalDenom,
    displayDenom: coinDenom,
    restURL: config.REST_URL,
    coinType: '118', // optional (default: '118')
    decimals: coinDecimals, // optional (default: 6)
    gasRate: {
        average: '0.0025',
        low: '0.001',
        tiny: '0.025',
    },
};
